import { useTranslation } from "react-i18next";
import { convertNumberToCurrency } from "@monorepo/helpers";
import { useGetMyVouchersQuery } from "@monorepo/services/api/vouchers";
import { styled, Typography } from "@mui/material";

interface IGsmSingleVoucher {
  voucherId: string;
}

const OuterWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));
const GsmSingleVoucher: React.FC<IGsmSingleVoucher> = ({ voucherId }) => {
  const { t } = useTranslation();
  const { voucher, isVoucherLoading } = useGetMyVouchersQuery(undefined as void, {
    selectFromResult: ({ data, isLoading }) => ({
      voucher: data?.find(({ id }) => id === voucherId),
      isVoucherLoading: isLoading,
    }),
  });

  if (!voucher || isVoucherLoading) return null;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { purchase_date, valid_date, gsm_code, price, instruction } = voucher;

  return (
    <OuterWrapper>
      <Typography component="span">
        {t("gsmVoucherServices.valid_date")}&nbsp;
        {purchase_date.split(" ")[0]}
      </Typography>
      <Typography component="span">
        {t("gsmVoucherServices.code_valid_to")}&nbsp;
        {valid_date}
      </Typography>
      <Typography component="span">
        {t("gsmVoucherServices.gsm_code")}&nbsp;
        {gsm_code}
      </Typography>
      <Typography mb={4} component="span">
        {t("gsmVoucherServices.gsm_sum")}&nbsp;
        {convertNumberToCurrency(price)}
      </Typography>
      <Typography component="span" dangerouslySetInnerHTML={{ __html: instruction }}></Typography>
    </OuterWrapper>
  );
};

export default GsmSingleVoucher;
